import React, { useState, useEffect, useRef } from 'react';
import { FiArrowUp, FiArrowDown, FiInfo } from "react-icons/fi";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import * as jobsActions from '../../Redux/Actions/jobs';
// import * as allDepartment from '../../Redux/Actions/department';
// import * as allMasterProcess from '../../Redux/Actions/masterProcess';
// import * as allProcess from '../../Redux/Actions/process';
import { toastMessage } from '../../utils/toast';
import { useSortableData } from '../../utils/sortableData';
import { clearSession } from '../../utils/initiate';
import { getParams, dateTimeFormat, useOnClickOutside } from '../../utils';
import {
    getJobMultiStatusState, getJobId, getFromDate, getToDate, getIsArdo, getDepartmentId, getMasterProcessId, getProcessId,
    getCspName, getClearFilterFlag, getDepartmentList, getMasterProcessList, getProcessList, reset, getIsAdditionalPayment, getReferenceName
} from '../../Redux/Reducers/jobFilter';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import '../../assets/table.css';
import DropDown from '../Ui/DropDown';
import DataCount from '../../utils/dataCount';
import { Line } from 'rc-progress';
import Loader from 'react-loader-spinner';
import { MultiSelect } from "react-multi-select-component";

const JobsManagement = ({ history }) => {
    let itemsPerPage = 10;
    const { jobStatusState, jobMultiStatusState, jobIdState, fromDateState, toDateState, isArdoState, departmentIdState, masterProcessIdState,
        processIdState, cspNameState, clearFilterFlag, departmentList, masterProcessList, processList, isAdditionalPayment, referenceName } = useSelector((state) => state.jobFilter);
    const [data, setData] = useState([]);
    const [type, setType] = useState('');
    const [statusList, setStatusList] = useState([]);
    // const [jobSelectedStatus, setJobSelectedStatus] = useState(jobStatusState);
    // const [filterID, setFilterID] = useState(jobIdState);
    // const [filterFromDate, setFilterFromDate] = useState(fromDateState);
    // const [filterToDate, setFilterToDate] = useState(toDateState);
    const [loading, setLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(() => parseInt(getParams(window.location.search).page) || 1);
    const { t } = useTranslation();
    // const [department, setDepartment] = useState('');
    // const [masterProcess, setMasterProcess] = useState('');
    // const [process, setProcess] = useState('');
    // const [departmentList, setDepartmentList] = useState([]);
    // const [masterProcessList, setMasterProcessList] = useState([]);
    // const [processList, setProcessList] = useState([]);
    // const [cspName, setCspName] = useState(cspNameState);
    // const [isAdro, setIsAdro] = useState(isArdoState);

    let params = getParams(window.location.search);
    let groupStatus = params.groupStatus;
    let countType = params.countType;
    const [popupNoteID, setPopupNoteID] = useState('');
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => { setIsReadMore(!isReadMore); };
    const ref = useRef();
    const userData = useSelector(({ User }) => User.data);
    // const [statusList_2, setStatusList_2] = useState([]);
    useOnClickOutside(ref, () => handleNotePopupClose());
    const [progressBarValue, setProgressBarValue] = useState(50);
    const [loadingCsv, setLoadingCsv] = useState(false);
    // const [departmentId, setDepartmentID] = useState(departmentIdState);
    // const [masterProcessId, setMasterProcessID] = useState(masterProcessIdState);
    // const [processId, setProcessID] = useState(processIdState);
    const [jobStatusMultipleOptions, setJobStatusMultipleOptions] = useState([]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setProgressBarValue((prev) => {
                if (prev >= 90) {
                    clearInterval(intervalId);
                    return 97;
                } else {
                    return prev + 10;
                }
            });
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        handleGetJobStatuses();
        filterMapping();
        // handleGetAllDepartment();
        // handleGetAllMasterProcess();
        // handleGetAllProcess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        handleGetAllJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearFilterFlag]);

    const filterMapping = () => {
        jobsActions.getAllServices().then((res) => {
            let departmentsList = res.data.departments;
            departmentsList = departmentsList.map(({ name, id, masterProcess }) => ({ "label": name, "value": id, "masterProcess": masterProcess }));
            departmentsList.unshift({ label: "Select Department", "value": 0, "masterProcess": [] });
            dispatch(getDepartmentList(departmentsList));
        }).catch((err) => {
            setErrStatus(err?.response?.status);
            (err?.response?.status === 401) && clearSession(dispatch, history);
        })
    }

    const handleList = (key, ID) => {
        let list = [];
        if (key === 'department') {
            list = departmentList.filter(({ value }) => value === ID)[0].masterProcess;
            list = list.map(({ name, id, process }) => ({ "label": name, "value": id, "process": process }));
            list.unshift({ label: "Select Department", "value": 0, "process": [] });
            dispatch(getMasterProcessList(list));
        } else {
            list = masterProcessList.filter(({ value }) => value === ID)[0].process;
            list = list.map(({ name, id }) => ({ "label": name, "value": id }));
            list.unshift({ label: "Select Master process", "value": 0 });
            dispatch(getProcessList(list));
        }
    }

    const handleGetAllJobs = () => {
        setLoading(true);
        const multiple = [];
        jobMultiStatusState.forEach(item => {
            multiple.push(item.value);
        });
        let payload = {
            jobStatusMultiple: multiple,
            jobStatus: jobStatusState,
            groupStatus: groupStatus,
            countType: countType,
            jobID: jobIdState,
            fromDate: fromDateState,
            toDate: toDateState,
            department: departmentIdState?.value,
            masterProcess: masterProcessIdState?.value,
            process: processIdState?.value,
            cspName: cspNameState,
            isAdro: isArdoState,
            additionalPaymentOnly: isAdditionalPayment,
            referenceName
        };
        jobsActions.getAll(payload).then(res => {
            if (res && res.data) {
                let jobData = [];
                res.data.map((form, index) => jobData.push({ 'sno': index + 1, ...form }));
                setData(jobData);
                setProgressBarValue(100);
            } else {
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the jobs`);
            }
            setLoading(false);
            setType('');
        }).catch(err => {
            setErrStatus(err?.response?.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    const { items, requestSort, sortConfig } = useSortableData(data);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);

    useEffect(() => {
        if (data.length > 0) {
            const maxPage = Math.ceil(data.length / itemsPerPage);
            if (currentPage > maxPage) {
                setCurrentPage(1);
                setItemOffset(0);
                const newParams = new URLSearchParams(window.location.search);
                newParams.set('page', 1);
                history.push({ search: newParams.toString() });
            } else {
                setItemOffset((currentPage - 1) * itemsPerPage);
            }
        }
    }, [data, currentPage, itemsPerPage, history]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage;
        setItemOffset(newOffset);
        const newPage = event.selected + 1;
        setCurrentPage(newPage);
        const newParams = new URLSearchParams(window.location.search);
        newParams.set('page', newPage);
        history.push({ search: newParams.toString() });
    };

    const handleGetJobStatuses = () => {
        jobsActions.getAllJobStatuses().then(({ data }) => {
            if (data) {
                setStatusList(data);
            }
        }).catch(err => {
            toastMessage('error', (err && err.message) || `Unable to get the job statuses`);
        });
    };

    // const handleGetAllDepartment = () => {
    //     allDepartment.getAll().then(({ data }) => {
    //         if (data) {
    //             let departmentList = data;
    //             departmentList = departmentList.map(({ id, name }) => ({ "label": name, "value": id }));
    //             setDepartmentList(departmentList);
    //         }
    //     }).catch(err => {
    //         toastMessage('error', (err && err.message) || `Unable to get the master process`);
    //     });
    // }

    // const handleGetAllMasterProcess = () => {
    //     allMasterProcess.getAll().then(({ data }) => {
    //         if (data) {
    //             let masterProcessList = data;
    //             masterProcessList = masterProcessList.map(({ id, name }) => ({ "label": name, "value": id }));
    //             setMasterProcessList(masterProcessList);
    //         }
    //     }).catch(err => {
    //         toastMessage('error', (err && err.message) || `Unable to get the master process`);
    //     });
    // }

    // const handleGetAllProcess = () => {
    //     allProcess.getAll().then(({ data }) => {
    //         if (data) {
    //             let processList = data;
    //             processList = processList.map(({ id, description }) => ({ "label": description, "value": id }));
    //             setProcessList(processList);
    //         }
    //     }).catch(err => {
    //         toastMessage('error', (err && err.message) || `Unable to get the process`);
    //     });
    // }

    const handleNotePopupClose = () => {
        setPopupNoteID('');
        setIsReadMore(true);
    }

    const handleClearFilter = () => {
        dispatch(reset());

        if (groupStatus || countType) {
            history.push('/jobs');
            window.location.reload();
        }
    }

    useEffect(() => {
        if (userData.Role === 'SUBADMIN') {
            let status = statusList.filter(({ value }) => value === 'AssignedToTypingCenter' || value === 'AwaitingResponse' || value === 'RequestCancellation' || value === 'RequestCompletion');
            // setStatusList_2(status);
            const temp = status.map(({ value, lable }) => ({ value, label: lable }));
            setJobStatusMultipleOptions(temp);
        } else {
            // setStatusList_2(statusList);
            const temp = statusList.map(({ value, lable }) => ({ value, label: lable }));
            setJobStatusMultipleOptions(temp);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusList]);

    const filterHandler = () => {
        if (jobMultiStatusState?.length || referenceName || jobStatusState || groupStatus || jobIdState || fromDateState || toDateState || departmentIdState?.value || masterProcessIdState?.value || processIdState?.value || cspNameState || isArdoState) {
            dispatch(getClearFilterFlag(clearFilterFlag + 1));
        }

        if (isAdditionalPayment) {
            dispatch(getClearFilterFlag(clearFilterFlag + 1));
        }
    };

    function getAllComplaintsDownloadDatas() {
        setLoadingCsv(true);
        const multiple = [];
        jobMultiStatusState.forEach(item => {
            multiple.push(item.value);
        });
        let payload = {
            jobStatusMultiple: multiple,
            jobStatus: jobStatusState,
            groupStatus: groupStatus,
            countType: countType,
            jobID: jobIdState,
            fromDate: fromDateState,
            toDate: toDateState,
            department: departmentIdState?.value,
            masterProcess: masterProcessIdState?.value,
            process: processIdState?.value,
            cspName: cspNameState,
            isAdro: isArdoState,
            additionalPaymentOnly: isAdditionalPayment,
            referenceName
        };
        jobsActions.downLoadCsv(payload).then((res) => {
            try {
                toastMessage('info', `Download in progress`);
                var blob = new Blob(["\ufeff", res.data]);
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                var fileName = 'jobsReport.csv';
                link.download = fileName;
                link.click();
            } catch (error) {
                console.log('err', error)
                toastMessage('error', "Something went wrong during file download!!");
            }
            setLoadingCsv(false);
        }).catch((err) => {
            setLoadingCsv(false);
            toastMessage('error', "Something went wrong during file download!!");
        })
    }

    if (errStatus === 400) {
        return <Warning history={history} />
    }

    return (
        <>
            {(type === '') && <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{t("jobsManagement.manageJobs.title")}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            <div className="card-body py-3">
                                <div className="tab-content">
                                    <div className='d-flex'>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.labelJobID")}</label>
                                            <input placeholder={t("jobsManagement.filters.enterID")} type="number" className="form-control me-3" name="Filter ID" value={jobIdState} onChange={(e) => { dispatch(getJobId(e.target.value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.referenceName")}</label>
                                            <input placeholder={t("jobsManagement.filters.referenceNamePlaceHolder")} type="text" className="form-control me-3" name="Filter ID" value={referenceName} onChange={(e) => { dispatch(getReferenceName(e.target.value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.LabelFromDate")}</label>
                                            <input type="date" className="form-control me-3" name="From Date" value={fromDateState} onChange={e => { dispatch(getFromDate(e.target.value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.LabelToDate")}</label>
                                            <input type="date" disabled={fromDateState === '' ? true : false} min={fromDateState} className="form-control me-3" value={toDateState} onChange={e => { dispatch(getToDate(e.target.value)); }} />
                                        </div>
                                    </div>
                                    <div className="d-flex mt-2">
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <DropDown isSearchable={true} label={t("jobSla.filters.labelDepartment")} placeholder={t("jobSla.filters.selectDepartment")} options={departmentList} value={departmentIdState} onChange={value => { dispatch(getProcessList([])); handleList('department', value.value); dispatch(getDepartmentId(value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <DropDown isSearchable={true} label={t("jobSla.filters.labelMasterProcess")} placeholder={t("jobSla.filters.selectMasterProcess")} options={masterProcessList} value={masterProcessIdState} onChange={value => { handleList('masterProcess', value.value); dispatch(getMasterProcessId(value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <DropDown isSearchable={true} label={t("jobSla.filters.labelprocess")} placeholder={t("jobSla.filters.selectprocess")} options={processList} value={processIdState} onChange={value => { dispatch(getProcessId(value)); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("jobSla.filters.lableCspName")}</label>
                                            <input placeholder={t("jobSla.filters.enterCspName")} type="text" className="form-control me-3" style={{ height: '37px' }} name="CSP Name" value={cspNameState} onChange={(e) => { dispatch(getCspName(e.target.value)) }} />
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="me-3" style={{ width: '50%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("jobsManagement.filters.labelJobStatus")}</label>
                                            <MultiSelect
                                                options={jobStatusMultipleOptions}
                                                value={jobMultiStatusState}
                                                onChange={(e) => dispatch(getJobMultiStatusState(e))}
                                                labelledBy="Select job status"
                                            />
                                        </div>
                                        <div className="me-3 mt-4" style={{ width: '20%' }}>
                                            <input className="c-pointer" type="checkbox" checked={isArdoState} onChange={() => { dispatch(getIsArdo(!isArdoState)) }} />
                                            <label style={{ marginLeft: '3px' }}> Is Adro</label>
                                        </div>
                                        <div className="me-3 mt-4" style={{ width: '20%' }}>
                                            <input className="c-pointer" type="checkbox" checked={isAdditionalPayment} onChange={() => { dispatch(getIsAdditionalPayment(!isAdditionalPayment)) }} />
                                            <label style={{ marginLeft: '3px' }}> Is AdditionalPayment</label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between my-2">
                                        <div className="d-flex">
                                            <div className="d-flex align-items-end mb-3" style={{ width: '100%', whiteSpace: 'nowrap' }}>
                                                <button onClick={filterHandler} type="button" className="d-flex px-5 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                            </div>
                                            <div className="d-flex align-items-end mb-3 " style={{ width: '100%', whiteSpace: 'nowrap', marginLeft: '15px' }}>
                                                <button onClick={handleClearFilter} type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.clearFilters")}</button>
                                            </div>
                                        </div>
                                        {(userData.Role !== 'CALLCENTERSUPPORT') && <button className='btn btn-primary font-weight-bold d-flex align-items-center' disabled={loadingCsv} onClick={() => { getAllComplaintsDownloadDatas() }}>{t("refunds.export")} {(loadingCsv) && <Loader type="Oval" color="#fff" height={20} width={20} style={{ marginLeft: '5px' }} />}</button>}
                                    </div>
                                    {loading ? < Line percent={progressBarValue} strokeWidth={1} strokeColor="#2d207d" trailColor="#b71c1c" />
                                        : <div className="table-responsive" style={{ width: '100%', overflowX: 'scroll' }}>
                                            <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                                                <thead>
                                                    <tr className="text-left" >
                                                        {/* <th className="c-pointer pl-7" style={{width: '60px'}} onClick={() => requestSort('sno')}>
                                                            <span className={(sortConfig && (sortConfig.key === 'sno')) ? "text-primary" : "text-dark-75"}>{t("jobsManagement.manageJobs.sNo")} {(sortConfig && (sortConfig.key === 'sno')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span>
                                                        </th> */}
                                                        <th className="c-pointer" style={{ width: '75px' }} onClick={() => requestSort('id')}><span className={(sortConfig && (sortConfig.key === 'id')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.id")} {(sortConfig && (sortConfig.key === 'id')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('date')}><span className={(sortConfig && (sortConfig.key === 'date')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.paymentDate")} {(sortConfig && (sortConfig.key === 'date')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('cspName')}><span className={(sortConfig && (sortConfig.key === 'cspName')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.cspName")} {(sortConfig && (sortConfig.key === 'cspName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('agentName')}><span className={(sortConfig && (sortConfig.key === 'agentName')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.agentName")} {(sortConfig && (sortConfig.key === 'agentName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        {/* <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('date')}><span className={(sortConfig && (sortConfig.key === 'date')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.dateTime")} {(sortConfig && (sortConfig.key === 'date')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th> */}
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('fromUser')}><span className={(sortConfig && (sortConfig.key === 'fromUser')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.user")} {(sortConfig && (sortConfig.key === 'fromUser')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('referenceName')}><span className={(sortConfig && (sortConfig.key === 'referenceName')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.referenceName")} {(sortConfig && (sortConfig.key === 'referenceName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        {(userData.Role === 'SUPERADMIN' || userData.Role === 'SUBADMIN') && <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('fromUserMobile')}><span className={(sortConfig && (sortConfig.key === 'fromUserMobile')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.userMobile")} {(sortConfig && (sortConfig.key === 'fromUserMobile')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>}
                                                        <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('status')}><span className={(sortConfig && (sortConfig.key === 'status')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.status")} {(sortConfig && (sortConfig.key === 'status')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        {/* <th className="c-pointer" style={{ width: '150px' }} onClick={() => requestSort('department')}><span className={(sortConfig && (sortConfig.key === 'department')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.department")} {(sortConfig && (sortConfig.key === 'department')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th> */}
                                                        {/* <th className="c-pointer" style={{ width: '200px' }} onClick={() => requestSort('masterProcess')}><span className={(sortConfig && (sortConfig.key === 'masterProcess')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.masterProcess")} {(sortConfig && (sortConfig.key === 'masterProcess')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th> */}
                                                        <th className="c-pointer" style={{ width: '200px' }} onClick={() => requestSort('process')}><span className={(sortConfig && (sortConfig.key === 'process')) ? "text-secondary" : "text-dark-75"}>{t("jobsManagement.manageJobs.process")} {(sortConfig && (sortConfig.key === 'process')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                        <th style={{ width: '100px', position: 'sticky', left: '0px', zIndex: '40' }}><span className="text-dark-75">{t("jobsManagement.manageJobs.action")}</span></th>
                                                        <th style={{ width: '100px', position: 'sticky', left: '0px', zIndex: '40' }} ><span className="text-dark-75"></span>{t("jobsManagement.manageJobs.sNo")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentItems.map(({ sno, id, date, fromUser, department, masterProcess, process, status, toUser, typingCenterName, jobNotes, paymentPaidDate, fromUserMobile, referenceName }) => {
                                                        let statusClass = (status.toLowerCase() === 'completed') ? 'success' : ((status.toLowerCase() === 'cancelled') ? 'danger' : 'warning');
                                                        return (
                                                            <tr key={sno} style={{ backgroundColor: jobNotes.length > 0 ? '#e3f2fd' : 'inherit' }}>
                                                                {/* <td className="pl-7">
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                                </td> */}
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{id}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentPaidDate}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{typingCenterName}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{toUser}</span>
                                                                </td>
                                                                {/* <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{date}</span>
                                                                </td> */}
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{fromUser}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{referenceName ? referenceName : '-'}</span>
                                                                </td>
                                                                {(userData.Role === 'SUPERADMIN' || userData.Role === 'SUBADMIN') &&
                                                                    <td>
                                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{fromUserMobile}</span>
                                                                    </td>
                                                                }
                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                    <span className={"label me-1 label-outline-" + statusClass} style={{ borderRadius: '3px', width: 'auto' }}>{status}</span>
                                                                </td>
                                                                {/* <td className="pl-0 py-8">
                                                                    <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{department}</span>
                                                                </td> */}
                                                                {/* <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{masterProcess}</span>
                                                                </td> */}
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{process}</span>
                                                                </td>

                                                                <td className="pr-0">
                                                                    <p onClick={() => ['CALLCENTERSUPPORT', 'FINANCE', 'TRACKING'].includes(userData.Role) ? history.push(`/customer_job_reports/${id}`) : history.push(`/jobs/${id}`)} className="btn btn-info font-weight-bolder font-size-sm me-2">{t("jobsManagement.manageJobs.more")}</p>
                                                                    {(jobNotes.length === 0) ? null : <FiInfo className="c-pointer font-20 ms-lg-2" onClick={() => setPopupNoteID(id)} />}
                                                                    {(jobNotes.length === 0) ? null : <div>
                                                                        <div className="position-relative ms-2">
                                                                            {(popupNoteID === id) &&
                                                                                <div ref={ref} className="popover position-absolute fade show bs-popover-start" style={{ width: '300px', left: '-300px', top: '-70px' }}>
                                                                                    <div className="m-0 p-3 popover-body" style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                                        {jobNotes.map(({ id, createdTime, note, createdBy }) =>
                                                                                            <div key={id}>
                                                                                                <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '0px', paddingBottom: '5px' }}>
                                                                                                    {jobNotes && <span className="text-muted">{t("Date")} : </span>} {dateTimeFormat(createdTime)}
                                                                                                </div>
                                                                                                <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '0px', paddingBottom: '5px' }}>
                                                                                                    <span className="text-muted">{t("Note")} : </span> {isReadMore ? note.slice(0, 100) : note}
                                                                                                    {note.length > 150
                                                                                                        ? <span onClick={toggleReadMore} style={{ cursor: 'pointer', color: '#0f8bc9' }}> {isReadMore ? "...show more" : "...show less"}</span>
                                                                                                        : null
                                                                                                    }
                                                                                                </div>
                                                                                                <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                                                                                    {jobNotes && <span className="text-muted">{t("Created By")} : </span>} {createdBy}
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>}
                                                                        </div>
                                                                    </div>
                                                                    }
                                                                </td>
                                                                <td className="pr-0">
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                            {(pageCount > 1) && <ReactPaginate
                                                breakLabel="..."
                                                nextLabel=">"
                                                previousLabel="<"
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={5}
                                                pageCount={pageCount}
                                                forcePage={currentPage - 1}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                renderOnZeroPageCount={null}
                                            />}
                                            {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("jobsManagement.noDataAvailable")}</p>}
                                        </div>}
                                    {data.length > 0 && <DataCount itemOffset={itemOffset} items={items} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default JobsManagement;